import { apiGet } from '../../api'

export const get_facilitator_teaching_days = query => {
  return apiGet({
    endpoint: `teaching/get_teaching_days?${query}`
  })
}
